
export default class CampaignEanexSubmitData {

  public offerId: number | string;
  public optionId: number | string;
  public channel: string;
  public responseParams: object;
  public hash: string;


  constructor(offerId: number | string, optionId: number | string, channel: string, responseParams: object, hash: string) {
    this.offerId = offerId;
    this.optionId = optionId;
    this.channel = channel;
    this.responseParams = responseParams;
    this.hash = hash;
  }

}
